export enum ImageLoading {
  LAZY = 'lazy',
  EAGER = 'eager',
}
